{
  "about": {
    "paragraph": "我们致力于应对AGEC法律的挑战, 并向客户提供有关产品原产地和环境质量的信息。",
    "title": "关于"
  },
  "lastUpdate": "最后更新日期：",
  "loading": {
    "dataPending": "正在收集此信息",
    "pendingLocation": "位置待定"
  },
  "other": {
    "microplastics_bold": "释放微塑料",
    "paragraph1": "此产品包含",
    "paragraph1_100": "此产品包含100%回收材料。",
    "paragraph2_1": "此产品",
    "paragraph2_2": "洗涤时释放到环境中：",
    "paragraph2_3": "按质量计算，产品由合成纤维组成。",
    "paragraph3": "关于使用中可能存在的危险物质的信息：",
    "recycled_matertials_bold": "至少{{percent}}%的回收材料。",
    "recycled_matertials_bold_50": "超过50%",
    "title": "其他环境质量和特性"
  },
  "packaging": {
    "recyclable": "可回收：包装可回收。",
    "recycled": "回收材料：包装至少包含{{percent}}%的回收材料。",
    "recycled_100": "回收材料：包装包含100%的回收材料。",
    "title": "包装的环境质量和特性"
  },
  "title": "产品环境质量或特性表",
  "traceability": {
    "paragraph": "这涉及您产品在前三个生产阶段的原产地，从产品创建到主要材料的织造和染色。",
    "title": "产品可追溯性"
  }
}
